import { withDialogAction } from 'peach/decorators/withActionTrigger'

import DialogComponent, { DialogText, DialogActions } from './Dialog'

const Dialog = withDialogAction(DialogComponent)

export default Dialog
export { DialogText, DialogActions }
export { default as GenericConfirmDialog } from './GenericConfirmDialog'
